import { render, staticRenderFns } from "./PscIndex.vue?vue&type=template&id=6996f2f4&scoped=true&"
import script from "./PscIndex.vue?vue&type=script&lang=js&"
export * from "./PscIndex.vue?vue&type=script&lang=js&"
import style0 from "./PscIndex.vue?vue&type=style&index=0&id=6996f2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996f2f4",
  null
  
)

export default component.exports